import { useState, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import InputField from "./_components/InputField";
import SubmitButton from "./_components/SubmitButton";
import React from "react";
import Api from "../api/Api";

export default () => {
    const location = useLocation();
    const [token, setToken] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [loading, setLoading] = useState(true);
    const [tokenValid, setTokenValid] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        // Token kinyerése az URL-ből: ?token=xxx
        const query = new URLSearchParams(location.search);
        const urlToken = query.get('token');
        
        if (urlToken) {
            setToken(urlToken);
            checkToken(urlToken);
        } else {
            setLoading(false);
            setError('Hiányzó token!');
        }
    }, [location]);

    // token érvényesség ellenőrzése
    const checkToken = async (token) => {
        const isValid = await Api.validateResetToken(token);
        if (isValid) {
            setTokenValid(true);
        } else {
            setError('A link lejárt vagy érvénytelen!');
        }
        setLoading(false);
    }

    const handleReset = async () => {
        if (password !== passwordConfirm) {
            alert('A két jelszó nem egyezik!');
            return;
        }
        if (password.length < 6) {
            alert('A jelszó túl rövid!');
            return;
        }

        await Api.saveNewPassword(token, password);
    }

    if (loading) return <div className="container">Ellenőrzés...</div>;
    
    if (error) return (
        <div className="login-form">
            <div className="alert alert-danger">{error}</div>
            <Link to={'/forgotten-password'}>Új kérése</Link>
        </div>
    );

    return (
        <div className={"login-form"}>
            <h3>Új jelszó megadása</h3>
            <InputField
                type="password"
                placeholder="Új jelszó"
                value={password}
                onChange={(val) => setPassword(val)}
                autoComplete="new-password" // böngésző automatikus kitöltés ellen
            />
            <InputField
                type="password"
                placeholder="Új jelszó újra"
                value={passwordConfirm}
                onChange={(val) => setPasswordConfirm(val)}
                autoComplete="new-password" // böngésző automatikus kitöltés ellen
            />

            <SubmitButton
                text="Mentés"
                onClick={handleReset}
            />
            <br/><br/>
            <Link to={'/'}>Vissza a belépéshez</Link>
        </div>
    )
}